import { dataGet } from 'src/utils';
import SimAgentInfoBox from './sim_info/SimAgentInfoBox';
import SimEnterpriseInfoBox from './sim_info/SimEnterpriseInfoBox';
import SimInfoBox from './sim_info/SimInfoBox';
import SimUserInfoBox from './sim_info/SimUserInfoBox';

export default function SimInfoTab({ simDetail }: any) {
  return (
    <div className={'sim-info-tab'}>
      <SimInfoBox simDetail={simDetail} />
      <SimEnterpriseInfoBox
        accountAttribute={dataGet(simDetail, 'enterpriseProfile.accountAttribute')}
        idEnterprise={dataGet(simDetail, 'enterpriseProfile.id')}
      />
      <SimAgentInfoBox
        accountAttribute={dataGet(simDetail, 'enterpriseProfile.accountAttribute')}
      />
      <SimUserInfoBox simDetail={simDetail} />
    </div>
  );
}
